export function setLanguagePreferences(lang: string, localization: boolean, companylang?: string): void {
    localStorage.setItem('customerPreferredLanguage', lang);
    localStorage.setItem('companyLocalization', localization.toString());
    if (companylang !== undefined) {
        localStorage.setItem('companyPreferredLanguage', companylang);
    }
}

export function getLanguagePreferences(): { currentLang: string | null; companyLocalization: boolean, companyLang: string | null } {
    return {
        currentLang: localStorage.getItem('customerPreferredLanguage') || 'en',
        companyLang: localStorage.getItem('companyPreferredLanguage') || 'en',
        companyLocalization: localStorage.getItem('companyLocalization') === 'true',
    }
}